type OnCloseCallback = () => void;
interface EditorPanelAssetsListOptions {
	onClose?: OnCloseCallback;
}
import {ref, Ref} from 'vue';

export class EditorPanelAssetsListStoreControllerClass {
	private static _instance: EditorPanelAssetsListStoreControllerClass;
	static instance() {
		return (this._instance = this._instance || new EditorPanelAssetsListStoreControllerClass());
	}

	private constructor() {}

	private _displayed: Ref<boolean> = ref(false);
	private _onClose: OnCloseCallback | undefined;

	displayed(): boolean {
		return this._displayed.value;
	}

	// mutations
	open(options?: EditorPanelAssetsListOptions): void {
		this._displayed.value = true;
		this._onClose = options?.onClose;
	}
	close() {
		this._displayed.value = false;
		if (this._onClose) {
			this._onClose();
			this._onClose = undefined;
		}
	}
}

export const EditorPanelAssetsListStoreController = EditorPanelAssetsListStoreControllerClass.instance();
